import React, { useState } from 'react';
import { Text } from 'grommet';
import { FTTextInput } from '../../../components/inputs';

const MinRpsFloorInput = ({
  initialValue,
  disabled,
  itemId,
  onValidationChange,
  onChange
}) => {
  const [inputValue, setInputValue] = useState(initialValue ?? '');

  return (
    <FTTextInput
      min={0}
      max={1}
      step={0.000001}
      type='number'
      value={inputValue}
      disabled={disabled}
      icon={<Text>$</Text>}
      label='Min RPS Floor (not RPS guarantee)'
      tipContent='Setting an RPS Floor will reduce the number of sessions served. If the ML-Predicted RPS for a session falls below this value then this AdUnit will not be served which can affect session volume. Leave this field blank to disable the feature.'
      validate={value => {
        if (value === '') return null;
        const num = parseFloat(value);
        if (isNaN(num) || num < 0) return 'Must be 0 or greater.';
        if (num > 1) return 'Cannot exceed $1.00.';
        return null;
      }}
      onValidationChange={hasError =>
        onValidationChange?.({ id: itemId, hasValidationError: hasError })
      }
      onChange={newValue => {
        setInputValue(newValue);
        const num = parseFloat(newValue);
        const isValidFloor = !isNaN(num) && num >= 0 && num <= 1;
        onChange(newValue === '' || num === 0 ? null : isValidFloor ? num : newValue);
      }}
    />
  );
};

export default MinRpsFloorInput;
